import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import DepositHistoryPage from "components/pages/DepositHistoryPage";
import Classes, { Account, Deposit } from "model";

export default function CaptureMabiDepositsDepositHistory(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const account = Account.getDefaultBrandedAccountByType("checking");

    const deposit = Deposit.init({
        id: 100,
        date: 0,
        account: account.id,
        amount: 20,
        status: "Not Available",
        source: "Mobile Phone",
        isCheck: "true"
    });

    Deposit.create(deposit)
        .submit(Classes);

    
    return <DepositHistoryPage />
}